import {uniqueId} from 'lodash'
import { WITHOUT_STATUS, IN_PROGRESS, DELAYED } from '@/constants/requestStatuses'
import { AED_ICON } from '@/constants/icons'
import { REMINDER_STATUS } from '@/constants/recurReminders'

const columns = [
  {
    type: 'menu',
    width: '23px',
    buttons: [
      {
        title: 'Decline',
        displayed: [WITHOUT_STATUS.id],
        value: DELAYED.id
      },
      {
        title: 'Take forward',
        displayed: [WITHOUT_STATUS.id],
        value: IN_PROGRESS.id
      }
    ],
    showEdit: true,
    showComplete: true,
    showDeleted: true,
    isDoubleDelete: true
  },
  {
    type: 'index',
    width: '22px'
  },
  {
    title: 'Received on',
    prop: 'dateStart',
    type: 'date',
    width: 'minmax(92px, 0.5fr)'
  },
  {
    title: 'Type of Request',
    prop: 'name',
    isHashtag: 'tags',
    width: 'minmax(100px, 2fr)'
  },
  {
    type: 'accordion',
    prop: 'comments',
    width: '18px'
  },
  {
    hideHeaderAccordion: true,
    type: 'accordionContent',
    prop: 'comments',
    isNoClick: false,
    style: {
      gridRow: '2',
      gridColumn: '2/8'
    }
  },
  {
    width: 'minmax(0, 84px)'
  },
  {
    title: 'Client',
    display: 'client.nickName',
    prop: 'client',
    route: {
      name: 'ContactCard',
      paramName: 'id',
      paramValue: 'client._id',
      paramName2: 'contactType',
      paramValue2: 'client.contactType',
      newWindow: true
    },
    width: 'minmax(100px, 1fr)'
  },
  {
    title: 'Value,',
    iconTitle: AED_ICON,
    iconStyle: {
      margin: '0 0 0 2px'
    },
    type: 'number',
    prop: 'amount',
    width: 'minmax(80px, 80px)'
  },
  {
    title: 'Reminders',
    prop: 'reminders',
    type: 'reminder',
    reminderStatus: REMINDER_STATUS.REQUEST,
    isNoClick: false,
    pointerStyle: {
      left: '41px'
    },
    counterStyle: {
      left: '49px'
    },
    width: '80px'
  },
  {
    title: 'PM',
    type: 'image',
    display: 'projectManager.image.path',
    popup: 'projectManager.username',
    prop: 'projectManager',
    defaultIcon: 'user',
    isType: true,
    width: 'minmax(50px, 50px)'
  },
  {
    title: 'Time tracked',
    type: 'timer',
    instanceStatus: REMINDER_STATUS.REQUEST,
    isNoClick: false,
    prop: 'totalTime',
    width: 'minmax(85px, 85px)'
  }
]

const prefix = 'col_requests_'
const listOfRequestsColumns = columns.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export default listOfRequestsColumns



// WEBPACK FOOTER //
// ./src/constants/TablesSettings/listOfRequestsColumns.js